import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Box,
  Alert
} from '@mui/material';
import { Star, TrendingUp } from '@mui/icons-material';
import { memo } from 'react';
import LabeledInput from '../../../components/common/fields/LabeledInput';

interface RateOrderSectionProps {
  value: number;
  onChange: (value: number) => void;
}

const RateOrderSectionComponent = ({ value, onChange }: RateOrderSectionProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = parseFloat(e.target.value) || 0;
    // Ensure value is between 0 and 5
    const clampedValue = Math.max(0, Math.min(5, newValue));
    onChange(clampedValue);
  };

  return (
    <Card elevation={2}>
      <CardHeader
        avatar={<Star sx={{ color: '#ba2156' }} />}
        title={
          <Typography variant="h6" component="h3">
            Rate Top Order
          </Typography>
        }
        subheader={
          <Typography variant="body2" color="text.secondary">
            Set the minimum rating required for top-priority order processing
          </Typography>
        }
      />
      <CardContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <LabeledInput
            label="Minimum Rating (0 - 5)"
            type="number"
            inputProps={{ min: 0, max: 5, step: 0.1 }}
            value={value || ''}
            required
            onChange={handleChange}
          />
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <TrendingUp sx={{ fontSize: 16, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              Salon with ratings from {value || 0}+ star will be prioritized
            </Typography>
          </Box>

        </Box>
      </CardContent>
    </Card>
  );
};

export const RateOrderSection = memo(RateOrderSectionComponent);